__turbopack_context__.v({
  "actions": "CookieConsentDeclarationStatus-module__fUTvma__actions",
  "domains": "CookieConsentDeclarationStatus-module__fUTvma__domains",
  "mono": "CookieConsentDeclarationStatus-module__fUTvma__mono",
  "root": "CookieConsentDeclarationStatus-module__fUTvma__root",
  "row": "CookieConsentDeclarationStatus-module__fUTvma__row",
  "status": "CookieConsentDeclarationStatus-module__fUTvma__status",
  "updated": "CookieConsentDeclarationStatus-module__fUTvma__updated",
});
